import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const WorkTypeService = {
  getWorkTypes() {
    return httpClient.post(endPoints.getWorkTypes);
  },
  updateWorkType(obj) {
    return httpClient.post(endPoints.updateWorkType, obj);
  },
  addWorkType(obj) {
    return httpClient.post(endPoints.addWorkType, obj);
  },
  deleteWorkType(obj) {
    return httpClient.post(endPoints.deleteWorkType, obj);
  }
};

export default WorkTypeService;



// WEBPACK FOOTER //
// ./src/service/WorkTypeService.js